"use strict";

require("es6-promise-promise");
require("whatwg-fetch");

const $ = require("jquery");
const checkStatus = require("./check-status.js");
const showQuestion = require("./show-question.js");
const SVGInjector = require("svg-injector");
const questionFilter = require("./questionFilter.js") ;

module.exports = $oElem => questionnaire => {
  const QuestionFilter = new questionFilter(questionnaire.questions) ;
  //const getQuestionData = p_iPosition => questionnaire.questions[p_iPosition];
  const getQuestionData = p_iPosition => QuestionFilter.getByIndex([p_iPosition]);
  const sLanguage = questionnaire.testLanguage ;

  $(".btnNext").show();
  $(".btnPrevious").show();

  let iPosition = 0;
  let iPrevious = iPosition - 1;
  let iNext = iPosition + 1;

  let questionnaireId = questionnaire.id;
  //let iTotalQuestions = QuestionFilter.length;

  let iCurrentQuestionId = questionnaire.questions[iPosition].questionId;
  let sQuestionnaireName = questionnaire.name;
  let sQuestionnaireResultText = questionnaire.resultText;

  let oAnswers = {};
  if (iPrevious < 0) {
    iPrevious = 0;
  }

  const checkState = function() {
    let iCurrentPosition = iPosition - 1;

    if (oAnswers[iPosition + 1] || oAnswers[iPosition]) {
      $(".btnNext").removeAttr("disabled", "disabled");
      $(".btnNext").css("visibility", "visible");
    } else {
      $(".btnNext").attr("disabled", "disabled");
      $(".btnNext").css("visibility", "hidden");
    }

    if (oAnswers[iPosition - 1]) {
      $(".btnPrevious").removeAttr("disabled", "disabled");
      $(".btnPrevious").css("visibility", "visible");
    } else {
      $(".btnPrevious").attr("disabled", "disabled");
      $(".btnPrevious").css("visibility", "hidden");
    }

    if (oAnswers[iPosition]) {
      $(
        '.questionAnswer[data-answerid="' + oAnswers[iPosition].answerId + '"]'
      ).addClass("active");
    }
  };

  $(".btnPrevious").on("click", function() {
    iPosition--;
    if (iPosition >= 0) {
      questionHandler(getQuestionData(iPosition).questionId);
    } else {
      iPosition = 0;
    }
  });

  $(".btnNext").on("click", function() {
    iPosition++;
    if (iPosition < QuestionFilter.length) {
      questionHandler(getQuestionData(iPosition).questionId);
    } else {
      iPosition--;
    }
  });

  if(sLanguage == 'EN'){
    $(".btnPrevious").html('Previous') ;
    $(".btnNext").html('Next') ;
  }


  const handleAnswer = function(oAnswer) {

    const question = getQuestionData(iPosition) ;

      const iScore = oAnswer.score;
      const iAnswerId = oAnswer.answerId;
      oAnswers[iPosition] = {
          ...getQuestionData(iPosition),
          answer: iScore,
          answerId: iAnswerId
      };

     if(question.questionType == 'sectionExcludeFilter'){

       QuestionFilter.addSkip(iPosition, oAnswer.score);
    }
  };

  const addQuestionEvents = function() {
    return new Promise(function(resolve) {

      $oElem.find('.questionAnswer').off('click') ;

      $oElem.find(".questionAnswer").on("click", function() {
        $oElem.find(".questionAnswer").each(function() {
          $(this).removeClass("active");
        });
        $(this).addClass("active");
        const iScore = $(this).data("score");
        const iAnswerId = $(this).data("answerid");

        setTimeout(function() {
          resolve({ score: iScore, answerId: iAnswerId });
        }, 500);
      });
    });
  };

  const insertQuestion = function(iCurrentQuestionId) {
    return fetch(
      HOME_URL+"api/questionnaire/" +
        questionnaireId +
        "/question/" +
        iCurrentQuestionId
        , {mode: 'cors'}

    )
      .then(checkStatus)
      .then(
        showQuestion(
          $oElem.find(".modal-body"),
          sQuestionnaireName,
          iPosition,
          sLanguage,
            QuestionFilter.length
        )
      )
      .then(checkState)
      .then(addQuestionEvents)
      .then(handleAnswer)
      .then(function() {
        iPosition++;
        //checkButtonState() ;
        if (iPosition < QuestionFilter.length) {
          return insertQuestion(getQuestionData(iPosition).questionId);
        } else {
          return oAnswers;
        }
      });
  };


  const handleEndResult = function(p_oAnswers) {
    fetch(HOME_URL+"api/questionnaire/calculate/" + questionnaireId + "?lang=" + sLanguage, {
      method: "POST",
      body: JSON.stringify(p_oAnswers)
    })
      .then(checkStatus)
      .then(function(response) {
        if(window.externalTest) {
            window.oCalculatedResult = response;
            $('#yltMtcModal').hide() ;
        }else {
            const template = require("./templates/result.hbs");

            for (const key in response.score) {
              response.score[key] = Object.values(response.score[key])
                  .filter(score => score.directModuleLinkId)
                  .map(score => {
                    return {
                      ...score,

                      accountRedirectUrl: window.sLandingspaginaUrl + '?o=' + window.sOrganisationHash + '&b=' + score.directModuleLinkId + '&c=r&' + response.totalAdvice
                    };
                  }

                  )

              response.score[key].showExpand = (response.score[key].length > 4);

            }

            let sQuestionnaireTitle = 'Resultaten - ' + sQuestionnaireName ;
            let oIntroText = {part1: 'We hebben jouw resultaten verdeeld in een aantal categorieën.', part2: 'Bekijk ze hieronder.'} ;
            let sButtonLabel = 'Aan de slag' ;
            if(sLanguage == 'EN'){
              oIntroText = {part1: 'We have divided your results into a number of categories.', part2: 'Check them out below.'} ;
                sButtonLabel = 'Get started' ;
            }


            const html = template({
              questionnaireTitle: sQuestionnaireTitle,
              introText: oIntroText,
              questionnaireResultText: sQuestionnaireResultText,
              buttonLabel:  sButtonLabel,
              result: response,
              imageUrl: HOME_URL + "/wp-content/plugins/ylt-mtc/public/img/de6sleutels.png",
              baseUrl: HOME_URL,
              redirectUrl: window.sLandingspaginaUrl + '?o=' + window.sOrganisationHash + '&c=r&' + response.totalAdvice
            });

            $("#nvtButton").hide();
            $oElem.find(".modal-body").html(html);

            $(".btnNext").hide();
            $(".btnPrevious").hide();

            var mySVGsToInject = document.querySelectorAll(
                ".sections .svg .img-holder img"
            );

            if (mySVGsToInject.length) {
              SVGInjector(mySVGsToInject);
            }
        }
      });
  };

  const questionHandler = function(questionId) {
    insertQuestion(questionId).then(handleEndResult);
  };

  questionHandler(iCurrentQuestionId);
};
